import React, { useEffect, useState } from "react";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import { Card, Col, Row, OverlayTrigger, Popover } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import "./choicecontributions.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useSelector } from "react-redux";
const ChoiceContributions = (props) => {
  const { chooseRetirementSteps, taxfreecash } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const [selectedCheck, setSelectedCheck] = useState(false);
  const { isFinalPage, setIsFinalPage } = props;

  useEffect(() => {
    const isFinal = handleFinalPage();
    setIsFinalPage(isFinal);
  }, [chooseRetirementSteps, taxfreecash]);

  const handleFinalPage = () => {
    if (
      chooseRetirementSteps?.isTakeMoneyInOneGo ||
      chooseRetirementSteps?.isTakeMoneyInOneChunk ||
      chooseRetirementSteps?.isAnnuityHowMuchCash ||
      (chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
        !taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome)
    ) {
      return true;
    } else {
      return false;
    }
  };

  function handleCheck(item) {
    setSelectedCheck(item);
  }

  const checkBoxData = [
    {
      checkboxName: "contributiondate",
      label: "Yes",
    },
    {
      checkboxName: "contributiondate",
      label: "No",
    },
  ];

  const handleBack = () => {
    if (chooseRetirementSteps?.isTakeMoneyInOneGo) {
      props.makeInitialStepper(false, 34, { isConfirmChoice: true }, true);
    } else if (chooseRetirementSteps?.isTakeMoneyInOneChunk) {
      props.makeInitialStepper(false, 35, { isConfirmChoice: true }, true);
    } else if (
      chooseRetirementSteps?.isAnnuityHowMuchCash ||
      chooseRetirementSteps?.isRegularHowMuchCash ||
      chooseRetirementSteps?.isMixMatchHowMuchCash ||
      (chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
        !taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome)
    ) {
      props.makeInitialStepper(false, 36, { isConfirmChoice: true }, true);
    }
  };
  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_CONTRIBUTION;
    let yourContribution = {
      continueContribution: selectedCheck?.label === "Yes",
      employerDateOfLeaving: selectedCheck?.label === "Yes" ? "" : "2026-05-30",
    };
    let payload = {
      currentStep,
      choiceCategory: {
        yourContribution,
        choiceSubmitted: isFinalPage,
        choiceSelected:
          isFinalPage && chooseRetirementSteps?.isTakeMoneyInOneGo
            ? "TAKE_ALL_IN_ONE_GO"
            : isFinalPage && chooseRetirementSteps?.isTakeMoneyInOneChunk
              ? "TAKE_MONEY_IN_CHUNKS"
              : isFinalPage && chooseRetirementSteps?.isAnnuityHowMuchCash
                ? "TAKE_GUARANTEED_INCOME_ANNUITY"
                : isFinalPage &&
                    chooseRetirementSteps?.isTakeTaxFreeCashInvestRest &&
                    !taxfreecash?.choiceCategory?.taxFreeCash?.isRegularincome
                  ? "TAKE_TAX_FREE_CASH_LUMSUM_INVEST_THE_REST"
                  : "",
      },
    };
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_CONTRIBUTION,
      payload, // eslint-disable-line
    );
  };
  const smallPotBenefitsToolTip = (
    <Popover id="popover-contained" className="tooltip-popover-section">
      <Popover.Body className="tooltip-popover-body">
        <p>
          A small pot may be an option when your entire pension pot is worth
          less than £10,000.
        </p>
        <p>
          You take your entire pension pot as a lump sum usually, the first 25%
          will be tax-free. The remaining 75% will be taxed as earnings.
        </p>
        <p>
          &apos;Small pots&apos; works slightly differently to the standard ways
          of taking your pension flexibly, in that you have to stop membership
          of the plan and there are rules we would need to check whether you had
          transferred in or out in the past few years. This is because for small
          pots, no other tests against the value of retirement benefits apply.
        </p>
        <p>
          To be eligible for a small pot you must not be a controlling director
          i.e., a director controlling over 20% share capital of a sponsoring
          employer or related scheme (or a person connected to a controlling
          director).
        </p>
      </Popover.Body>
    </Popover>
  );
  return (
    <Card className="application-step">
      <Card.Body className="choice-contributions">
        <Row>
          <Col md={10}>
            <div>
              <h2 className="heading">Your contributions</h2>
              <p>
                We see that you’re still paying into your pension pot. If you
                are stopping contributions or leaving your employer’s pension
                scheme, we will need your leaving date and final contribution
                from your employer before we can process your application.
                Kindly ask your employer to let us know as soon as possible.
              </p>
              <p className="mb-0">
                Do you intend to continue contributing to your pension?
              </p>
              <div className="check-box harizontal">
                {checkBoxData?.map((item, index) => {
                  return (
                    <div key={index}>
                      <CustomCheckbox
                        name="Check"
                        label={item.label}
                        variantName="custom-checkbox mt-3"
                        onChange={() => handleCheck(item)}
                      />
                    </div>
                  );
                })}
              </div>
              <p>
                Taking benefits from your TPT pension pot doesn’t interrupt any
                ongoing contributions that you and your employer are making.
                You’d simply build up further pension savings in your TPT pot
                that you could take out in the future.
              </p>
              <p>
                The only exception to this is if you’ve taken a lump sum of up
                to £10,000 under the ‘small pots’ rules
                <OverlayTrigger
                  placement="right"
                  overlay={smallPotBenefitsToolTip}
                >
                  <span className="icon-margin ms-1">
                    <Icons iconname="tool-tip" variant="icon-twelve-px" />
                  </span>
                </OverlayTrigger>
                , in which case you’ll need to leave your employer’s pension
                scheme and take all the pension savings you hold with TPT as a
                lump sum.
              </p>
            </div>
            {selectedCheck.label === "No" ? (
              <dv>
                <h3 className="subheading">Date of leaving required</h3>
                <p>
                  To complete your full application process we’ll need a date of
                  leaving from your current employer. You can still continue to
                  complete the rest of this application.
                </p>
              </dv>
            ) : (
              ""
            )}
            <div className="footer-btn-container">
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />

              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
                disabled={selectedCheck ? false : true}
              />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default ChoiceContributions;
